<template>
    <div class="m-login__signup" style="display: block;">
        <div class="m-login__head">
            <h3 class="m-login__title">Sign Up</h3>
            <div class="m-login__desc">Enter your details to create your account:</div>
        </div>
        <form class="m-login__form m-form" action="">
            <div class="form-group m-form__group">
                <input class="form-control m-input" type="text" placeholder="Fullname" name="fullname" v-model="user.name">
            </div>
            <div class="form-group m-form__group">
                <input class="form-control m-input" type="text" placeholder="Email" name="email" autocomplete="off" v-model="user.email">
            </div>
            <div class="form-group m-form__group">
                <input class="form-control m-input" type="password" placeholder="Password" name="password" v-model="user.password">
            </div>
            <div class="form-group m-form__group">
                <input class="form-control m-input m-login__form-input--last" type="password" placeholder="Confirm Password" name="rpassword" v-model="validatePassword">
            </div>
            <div class="row form-group m-form__group m-login__form-sub">
                <div class="col m--align-left">
                    <label class="m-checkbox m-checkbox--focus">
                        <input type="checkbox" name="agree" v-model="user.cgu"> I Agree the <a href="#" class="m-link m-link--focus">terms and conditions</a>.
                        <span></span>
                    </label>
                    <span class="m-form__help"></span>
                </div>
            </div>
            <div class="m-login__form-action">
                <button id="m_login_signup_submit" class="btn btn-focus m-btn m-btn--pill m-btn--custom" @click="subscribeAction">Sign Up</button>
                <router-link tag="button" to="/" id="m_login_signup_cancel" class="btn btn-outline-focus  m-btn m-btn--pill m-btn--custom">Cancel</router-link>
            </div>
        </form>
    </div>
</template>

<script>
import { HTTP } from '../../assets/js/axiosConfig'

export default {
    name: 'Subscribe',
    data () {
        return {
            user: {
                name: '',
                email: '',
                password: '',
                cgu: false
            },
            validatePassword: ''
        }
    },
    methods: {
        subscribeAction () {
            HTTP.post('signup', this.user).then((response) => {
                console.log('login success', response)
            })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Security/Subscribe.vue